import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import iconHome from "../assets/images/home.svg";
import iconTrend from "../assets/images/flame.svg";
import iconWheel from "../assets/images/wheel.svg";
import iconPromo from "../assets/images/promo.svg";
import iconPerfil from "../assets/images/profile.svg";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHalloween, setIsHalloween] = useState(false);

  useEffect(() => {
    const month = new Date().getMonth(); // Enero = 0, Octubre = 9
    setIsHalloween(month === 9); // true solo en octubre
  }, []);

  const isAuthenticated = () => {
    return !!localStorage.getItem("userData");
  };

  const tabs = [
    {
      path: "/",
      icon: <img src={iconHome} alt="Inicio" width="22" height="22" />,
      label: "Inicio",
    },
    {
      path: "/trending",
      icon: <img src={iconTrend} alt="Tendencias" width="24" height="24" />,
      label: "Tendencias",
      toastMsg: "Debes iniciar sesión para acceder a esta característica",
      protected: true,
    },
    {
      path: "/ruleta",
      icon: <img src={iconWheel} alt="Ruleta" width="22" height="22" />,
      label: "Ruleta",
      toastMsg: "Debes iniciar sesión para usar la ruleta",
      protected: true,
    },
    {
      path: "/ofertas",
      icon: <img src={iconPromo} alt="Promociones" width="23" height="23" />,
      label: "Ofertas",
    },
    {
      path: "/perfil",
      icon: <img src={iconPerfil} alt="Perfil" width="23" height="23" />,
      label: "Perfil",
      protected: true,
    },
  ];

  return (
    <nav className={`bottom-nav ${isHalloween ? "bottom-nav-halloween" : ""}`}>
      {tabs.map((tab) => (
        <div
          key={tab.label}
          className={`nav-item ${location.pathname === tab.path ? "active" : ""}`}
          onClick={() => {
            if (tab.protected && !isAuthenticated()) {
              if (tab.toastMsg) {
                toast.dismiss();
                toast.error(tab.toastMsg);
              }
              navigate("/login", { replace: true });
            } else {
              if (location.pathname === "/" && tab.path === "/") {
                window.location.reload();
              } else {
                navigate(tab.path, { replace: true });
              }
            }
          }}
        >
          {tab.icon}
        </div>
      ))}
    </nav>
  );
};

export default BottomNavigation;
